var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pb-0 pt-0",attrs:{"cols":"12","md":"12"}},[_c('v-data-table',{staticClass:"mb-4 custom-table",attrs:{"headers":_vm.headers,"items-per-page":1000,"items":_vm.mandates,"loading":false,"hide-default-footer":true},scopedSlots:_vm._u([{key:"item.mandate_kind",fn:function(ref){
var item = ref.item;
return [_c('el-table-enum',{attrs:{"enumName":"objectType","item":item.mandate_kind}})]}},{key:"item.index",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatedIndex(index)))])]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }